
import {
  CustomsPacking,
  HqPackingListDetail,
  Money,
  SecondaryPackingInfo
} from "@/model/HqPackingListModels";
import { Component, Vue } from "vue-property-decorator";
import { deleteBulkProduct, getHqPackingListDetailForEdit } from "@/api/hq-packing-list";
import HqPackingListProductList from "@/views/components/HqPackingListProductList.vue";
import {
  deleteCustomsPacking,
  updateCustomsPackingInfo,
  updateProductQuantity,
  updateSecondaryQuantity
} from "@/api/customs-packing";
import { cloneDeep } from "lodash";
import { putHandelWeight } from "@/api/customs-packing"

@Component({
  name: "HqPackingListDetailForEdit",
  components: { HqPackingListProductList }
})

export default class extends Vue {
  private hqPackingListId: string;
  private hqPackingListDetail: HqPackingListDetail = null;
  private editCustomsPackingSet: CustomsPacking[] = [];
  private editSecondaryPackingInfoSet: SecondaryPackingInfo[] = [];
  private editPackageInfoDialogVisible = false;
  private idAndPopoverMap: { [key: string]: boolean | undefined } = {};
  private type = "";

  private paramsRules = {
    increase: [
      { required: true, message: "请选择修改模式", trigger: "blur" },
    ]
  }

  private paramsWeight = {
    hqPackingListId: null,
    increase: null,
    netWeight: 0,
    grossWeight: 0,
  } as any;

  created() {
    this.type = this.$route.params.type;
    this.hqPackingListId = this.$route.params.hqPackingListId;
    this.getList();
  }

  private getPackageInfoShow(value: string) {
    if (this.type === "factory-loading-plan") {
      return true;
    }
    if(
        this.$route.meta.buttonCodes &&
        Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes(value);
    }
  }

  private async getList() {
    const details: any = await getHqPackingListDetailForEdit(this.hqPackingListId);
    this.hqPackingListDetail = details.hqPackingList;
  }

  private async handleEditProductNumber(productId: string, totalPcs: number) {
    await updateProductQuantity(productId, { quantity: totalPcs });
    await this.getList();
  }

  private async handleEditSecondaryNumber(secondaryPackingId: string, ctnQuantity: number) {
    await updateSecondaryQuantity(secondaryPackingId, { quantity: ctnQuantity }).then(() => {
      this.$notify({
        title: "成功",
        message: "修改成功",
        type: "success",
        duration: 2000
      });
    });
    await this.getList();
  }

  private async handleDeleteCustomsPacking(customsPackingId: string) {
    await deleteCustomsPacking(customsPackingId);
    await this.getList();
  }

  private async handleDeleteProduct(productId: string) {
    await deleteBulkProduct(productId);
    await this.getList();
  }

  private handleEditPackageInfo(customsPackingId: string) {
    console.log("进来了")
    const customsPackingSet: CustomsPacking[] = this.hqPackingListDetail?.customsPackingSet.filter(value => value.id === customsPackingId);
    this.editCustomsPackingSet = cloneDeep(customsPackingSet);
    this.editSecondaryPackingInfoSet = this.editCustomsPackingSet[0].secondaryPackingSet
        .flatMap(value =>
        value.packingInfos.map(info => ({
          ...JSON.parse(JSON.stringify(info)),
          cartonNumber: value.cartonNumber // 直接覆盖或新增属性
        }))
    );
    console.log("this.editSecondaryPackingInfoSet",this.editSecondaryPackingInfoSet)
    this.editPackageInfoDialogVisible = true;
  }

  private async onDialogConfirmed() {
    const writePackingInfoInput = new WritePackingInfoInput(this.editCustomsPackingSet[0]);
    writePackingInfoInput.secondaryPackingInfos = this.editSecondaryPackingInfoSet;
    await updateCustomsPackingInfo(writePackingInfoInput.id, writePackingInfoInput);
    this.clearEditPackingData();
    this.editPackageInfoDialogVisible = false;
    await this.getList();
  }

  private clearEditPackingData () {
    this.editCustomsPackingSet = [];
    this.editSecondaryPackingInfoSet = [];
  }

  private submitEdit() {
    (this.$refs['paramsWeight'] as any).validate(async (valid) => {
      if (valid) {
        this.paramsWeight.hqPackingListId = this.hqPackingListId
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        await putHandelWeight(this.paramsWeight).then(res => {
          this.showEditDio = false;
          this.getList();
          loading.close();
          this.paramsWeight = {
            hqPackingListId: null,
            increase: null,
            netWeight: 0,
            grossWeight: 0,
          } as any;
        }).catch(err => {
          console.log(err);
          loading.close();
        })
      }
    });
  }

  private showEditDio = false;
  private handleEdit() {
    this.showEditDio = true
  }

  private showDeleteCustomsPackingPopover(customsPackingId: string) {
    Object.keys(this.idAndPopoverMap).map(value => this.idAndPopoverMap[value] = false);
    this.idAndPopoverMap[customsPackingId] = true;
  }

  // private showBulkProductDeletePopover(productId: string){
  //   Object.keys(this.productInfoIdAndPopoverMap).map(value => this.productInfoIdAndPopoverMap[value] = false)
  //   this.productInfoIdAndPopoverMap[customsPackingId] = true;
  // }
  public getMoneyTotalAmount(moneyList:Money[],deduction: boolean): number{
   return moneyList
  .filter(item => item.deduction === deduction)
  .reduce((sum, item) => sum + item.value, 0);
  }
   getMoneyInfo(moneyList:Money[],deduction: boolean): string{
   return moneyList
  .filter(item => item.deduction === deduction)
  .map(item => `${item.type.desc}: ${item.value}`)
  .join();
  }

}

class WritePackingInfoInput {
  id: string;
  grossWeight: number;
  netWeight: number;
  length: number;
  width: number;
  height: number;
  secondaryPackingInfos: SecondaryPackingInfo[];

  constructor(customsPacking: CustomsPacking) {
    this.id = customsPacking.id;
    this.grossWeight = customsPacking.grossWeight;
    this.netWeight = customsPacking.netWeight;
    this.length = customsPacking.length;
    this.width = customsPacking.width;
    this.height = customsPacking.height;
    this.secondaryPackingInfos = customsPacking.secondaryPackingSet
      .map(value => value.packingInfos)
      .reduce((pre, cur) => pre.concat(cur), []);
  }
}


